<template lang="pug">
  .curriculum-receiver
    div(class="to") TO :
    avatar-image.avatar-image(
      :src="student.avatarImageUrl"
      purpose="receiver")
    .receiver {{ student.name }}
</template>

<style lang="scss" scoped>
.curriculum-receiver {
  display: flex;
  margin: 16px 16px 2px 16px;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.04);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  height: 64px;

  .to {
    width: 32px;
    margin: 25px 0 0 16px;
    @extend %label-text;
  }

  .receiver {
    margin: 20px 16px 16px 8px;
    @extend %headline-lists-text;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 70%;
  }

  .avatar-image {
    margin: 16px 8px;
  }
}
</style>

<script>
import AvatarImage from '@/components/atoms/AvatarImage'

export default {
  props: {
    student: { type: Object, required: true },
  },
  components: { AvatarImage },
}
</script>
